let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("feh32")).then(() => parcelRequire('fP0nh'));